module.exports = __webpack_public_path__ + "media/images/ui-bg_glass_55_fbf9ee_1x400-bd8c5ba738000caeb8ed563509a4efa3.png";